/* @flow */
import * as React from 'react';
import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { Trans, translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import { ElectroButton } from 'components/ExtendedUiElements/customized.js';

import type { TypeWithEmailModel } from 'models/AccountModels';

import CentralForm from 'components/CentralForm/CentralForm.js';

import styles from 'common-scss/formstyles.module.scss';

//NewAccount.js

function NewAccountP({ t, emailModel }: TypeWithEmailModel & TranslatorProps): React.Element<*> {
  return (
    <CentralForm>
      <h1>{t('general:accounts.almost_there')}</h1>
      <p>
        <Trans i18nKey="general:accounts.messages.email_sent">
          <strong>{emailModel.email}</strong>
        </Trans>
        <br />
        {t('general:accounts.messages.verify_account')}
      </p>
      <hr />
      <Link to="/login" className={styles['button-anchor']}>
        <ElectroButton label={t('general:actions.sign_in')} color="primary" />
      </Link>
    </CentralForm>
  );
}

const NewAccount: (props: TypeWithEmailModel) => React.Element<*> = translate()(
  inject('emailModel')(observer(NewAccountP))
);

export default NewAccount;
